export default __webpack_public_path__ + "static/media/bus_logo.165b9494.png";